export default __webpack_public_path__ + "static/media/plus-icon-bold.dee4a002.svg";